import { gql } from "@apollo/client"

export const GET_JOBLIST_SUBSCRIPTION = gql`
    subscription Subscription($dateFrom: Date!, $dateTo: Date!) {
        jobInDateRange(dateFrom: $dateFrom, dateTo: $dateTo) {
            _id
            serial
            jobReference
            billable {
                _id
                account
                company
            }
            destination {
                _id
                account
                company
            }
            items {
                name
                code
                quantity
                unit
                pricePerItem
                kgPerUnit
                quantityLoaded
                quantityUnloaded
                _id
                itemId
            }
            origin {
                account
                company
                _id
            }
            originAddress {
                address
                gps
                _id
            }
            destinationAddress {
                address
                gps
                _id
            }
            jobStatus
            groupId
            assignedShift {
                shiftId
                vehicle
                driver
                shiftTemplate
                shiftStart
                shiftEnd
            }
            _metadata {
                deleted
            }
        }
    }
`
